import React from 'react';

import ShowOrHideOnBreakpoint from '../ShowOrHideOnBreakpoint';

import {IShowOnMobileProps} from './IShowOnMobile';

const ShowOnMobile = (props: IShowOnMobileProps) => {
	return <ShowOrHideOnBreakpoint query="<small" {...props} />;
};

export default ShowOnMobile;
